import React from 'react';

import { motion } from 'framer-motion';
import { FieldError } from 'react-hook-form';

type Error = string[] | FieldError;

function FormErrors({ className = 'text-danger text-xs mt-1 pt-0 mb-2', error }: { className?: string, error: Error }) {

    if (!error) return null;

    // NEXTJS SITE
    if(Array.isArray(error)) {
        return error.map((err: string, index: number) => (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              key={index}
            >
              <div className={`${className}`}>
                {err}
              </div>
            </motion.div>
          ));
    }

    // COLDFUSION PORTAL
    if(error.message) {
        return <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
        >
            <div className={`${className}`}>
            {error.message}
            </div>
        </motion.div>        
    }
}

export default FormErrors;